import {
    createApp
} from 'vue'
import {
    Button,
    Popup,
    Switch,
    Field,
    Overlay,
    Toast,
    Icon
} from 'vant';
import App from './App.vue'
import router from "./router"

const app = createApp(App);
app.use(router);
app.use(Button);
app.use(Popup);
app.use(Switch);
app.use(Field);
app.use(Overlay);
app.use(Toast);
app.use(Icon);
app.mount('#app');